<p-card>
    <p-table [value]="accessioningList" [tableStyle]="{'min-width': '50rem'}" #dt
        [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]" [loading]="loading"
        [paginator]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [globalFilterFields]="['sourcePlate','destPlate']" [columns]="cols"
        stateStorage="local" stateKey="accessioninglist-state">
        <ng-template pTemplate="caption">
            <div class="flex">
                <button pButton type="button" label="Clear" class="p-button-outlined" icon="pi pi-filter-slash" (click)="clear(dt)"></button>
                <button type="button" pButton icon="pi pi-file" iconPos="left" label="Export" (click)="dt.exportCSV()" style="margin-left: 0.5em;"></button>
                <span class="p-input-icon-left ml-auto">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="applyFilterGlobal($event)" placeholder="Global Filter" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr> 
                <th pSortableColumn="instrument" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Instrument
                        <p-sortIcon field="instrument"></p-sortIcon>
                        <p-columnFilter type="text" field="instrument" display="menu" operator="or"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="sourcePlate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Source Plate
                        <p-sortIcon field="sourcePlate"></p-sortIcon>
                        <p-columnFilter type="text" field="sourcePlate" display="menu" operator="or" [maxConstraints]="5"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="sourceWell" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Source Well
                        <p-sortIcon field="sourceWell"></p-sortIcon>
                        <p-columnFilter type="text" field="sourceWell" display="menu" operator="or"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="tip" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Tip
                        <p-sortIcon field="tip"></p-sortIcon>
                        <p-columnFilter type="text" field="tip" display="menu" operator="or"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="destPlate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Destination Plate
                        <p-sortIcon field="destPlate"></p-sortIcon>
                        <p-columnFilter type="text" field="destPlate" display="menu" operator="or"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="destWell" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Destination Well
                        <p-sortIcon field="destWell"></p-sortIcon>
                        <p-columnFilter type="text" field="destWell" display="menu" operator="or"></p-columnFilter>
                    </div>
                </th>
                <!--<th pSortableColumn="deckPosition" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Deck Position
                        <p-sortIcon field="deckPosition"></p-sortIcon>
                        <p-columnFilter type="text" field="deckPosition" display="menu"></p-columnFilter>
                    </div>
                </th>-->
                <th pSortableColumn="startDate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Start Date
                        <p-sortIcon field="startDate"></p-sortIcon>
                        <p-columnFilter type="date" field="startDate" display="menu" operator="or"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="retry" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Retry
                        <p-sortIcon field="retry"></p-sortIcon>
                        <p-columnFilter type="text" field="retry" display="menu" operator="or"></p-columnFilter>
                    </div>
                </th>
                <!--<th pSortableColumn="endDate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        End Date
                        <p-sortIcon field="endDate"></p-sortIcon>
                        <p-columnFilter type="date" field="endDate" display="menu"></p-columnFilter>
                    </div>
                </th>-->
                <th pSortableColumn="accessioningIncident" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Last Accessioning Incident
                        <p-sortIcon field="accessioningIncident"></p-sortIcon>
                        <p-columnFilter type="text" field="accessioningIncident" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="accessioningIncidentDate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Last Accessioning Incident Date
                        <p-sortIcon field="accessioningIncidentDate"></p-sortIcon>
                        <p-columnFilter type="date" field="accessioningIncidentDate" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="accessioningService" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Last Accessioning Service
                        <p-sortIcon field="accessioningService"></p-sortIcon>
                        <p-columnFilter type="text" field="accessioningService" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="accessioningServiceDate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Last Accessioning Service Date
                        <p-sortIcon field="accessioningServiceDate"></p-sortIcon>
                        <p-columnFilter type="date" field="accessioningServiceDate" display="menu"></p-columnFilter>
                    </div>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-accessioning>
            <tr (click)="rowClick(accessioning)">
                <td>{{accessioning.instrument}}</td>
                <td>{{accessioning.sourcePlate}}</td>
                <td>{{accessioning.sourceWell}}</td>
                <td>{{accessioning.tip}}</td>
                <td>{{accessioning.destPlate}}</td>
                <td>{{accessioning.destWell}}</td>
                <td>{{accessioning.startDate | date:'short'}}</td>
                <td>{{accessioning.retry}}</td>
                <td>{{accessioning.accessionIncident}}</td>
                <td>{{accessioning.accessionIncidentDate | date:'short'}}</td>
                <td>{{accessioning.accessionService}}</td>
                <td>{{accessioning.accessionServiceDate | date:'short'}}</td>
            </tr>
        </ng-template>
    </p-table>
</p-card>